import React from "react";
import AddCouponPanel from "./AddCouponPanel";
import UsersPanel from "./UsersPanel";
import SendEmailPanel from "./SendEmailPanel";
import UtilsPanel from "./UtilsPanel";

const panelDescriptions = {
  'Discount Codes': 'Create and manage redemption codes.',
  'Default Sessions': 'Operational defaults for generated sessions.',
  Users: 'Search, sort, and inspect registered users.',
  Email: 'Compose and schedule admin emails.',
  Utils: 'Run focused operational tools.',
};

export default function ViewPanel({ selectedTab }) {
  return (
    <section className="space-y-6 text-left text-white">
      <div className="border-b border-gray-800 pb-5">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-cyan-200/70">
          Admin
        </p>
        <h2 className="mt-2 text-2xl font-semibold text-gray-100">{selectedTab}</h2>
        <p className="mt-1 text-sm text-gray-500">{panelDescriptions[selectedTab]}</p>
      </div>

      <div className="min-h-[calc(100vh-220px)] rounded-xl border border-gray-800 bg-[#0b1020]/80 p-5 shadow-[0_20px_60px_rgba(0,0,0,0.18)] sm:p-6 lg:p-8">
        {selectedTab === 'Discount Codes' && <AddCouponPanel />}
        {selectedTab === 'Default Sessions' && <div className="text-gray-400">Default Sessions Content</div>}
        {selectedTab === 'Users' && <UsersPanel />}
        {selectedTab === 'Email' && <SendEmailPanel />}
        {selectedTab === 'Utils' && <UtilsPanel />}
      </div>
    </section>
  );
}
